import { render, staticRenderFns } from "./ImagesLABNonRecently_ViewGrpIDLab.vue?vue&type=template&id=97609ef8"
import script from "./ImagesLABNonRecently_ViewGrpIDLab.vue?vue&type=script&lang=js"
export * from "./ImagesLABNonRecently_ViewGrpIDLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports